var module = angular.module('octopusApp.infrastructure');

// A service that helps for building screens that auto-refresh from a service.
// You create a loop by attaching it to your scope (it will automatically stop looping
// when your scope is destroyed by Angular) and giving it a callback.
//
//   var loop = pollLoop.create($scope, function () {
//     return doSomethingThatReturnsAPromise();
//   });
//
// Start the loop using:
//
//   loop.start();                or
//   loop.startImmediately();
//
// The callback must return a promise. The loop will set a timeout to run again once
// the promise completes (success or fail) - that way if you have a 3 second poll loop,
// the 3 seconds starts from when your service call finishes, not from when it started.
//
// When you're finished polling, you can use:
//
//   loop.stop();
//
module.factory('pollLoop', function ($timeout, octopusLog) {
  return {
    create: function ($scope, callbackThatReturnsAPromise, options) {
      var normalTimeout = 1000 * 4; // 4 Seconds
      var longTimeout = 1000 * 60 * 3; // 3 Mins
      if(!isNaN(options)){
          normalTimeout = options;
          longTimeout = Math.max(longTimeout, normalTimeout);
      } else if(typeof options === 'object') {
          normalTimeout = options.normalTimeout || normalTimeout;
          if(options.disableLongTimeout) {
              longTimeout = null;
          } else {
              longTimeout = Math.max(options.longTimeout || longTimeout, normalTimeout);
          }
      }

      var nextTimeout = normalTimeout;
      var instance = {
        isRunning: false
      };
      var timeoutHandle = null;

      $scope.$on('$destroy', function () {
          instance.stop();
      });

      $scope.$on('PageVisibility', function(event, args) {
          nextTimeout = args.hidden ? (longTimeout || normalTimeout) : normalTimeout;
          instance.stop();
          instance.start();
      });

      instance.stop = function() {
        instance.isRunning = false;
        if(timeoutHandle) {
            $timeout.cancel(timeoutHandle);
            timeoutHandle = null;
        }
      };

      var startInternal = function (immediate) {
        if (instance.isRunning) {
          return;
        }

        instance.isRunning = true;
        var firstTime = true;
        var doTimeout = function () {
            timeoutHandle = $timeout(loop, nextTimeout);
        };

        var loop = function() {
          if (!instance.isRunning) {
            return;
          }

          if (!firstTime || immediate) {
            var prom = callbackThatReturnsAPromise();
            if (!prom) {
              octopusLog.error("The poll loop callback should return a promise");
            } else {
              prom.then(function () {
                doTimeout();
              }, function () {
                doTimeout();
              });
            }
          } else if (firstTime && !immediate) {
            doTimeout();
          }

          firstTime = false;
        };

        loop();
      };

      instance.startImmediately = function () {
        startInternal(true);
      };

      instance.start = function () {
        startInternal(false);
      };

      return instance;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/poll_loop.js
// module id = 2819315911409868
// module chunks = 1